export default {
  data() {
    return {
      roomCardRefs: [],
      rooms: [
        {
          title: "木光晨曦套房",
          description: "溫潤木質與柔和燈光營造溫馨氛圍，身心放鬆的住宿體驗。",
          route: "DawnwoodSuite",
          image: "room1-1.jpg", // 對應檔案名
          isVisible: false, // 新增這個屬性
        },
        {
          title: "木光森居套房",
          description: "木質牆面與溫暖燈光，營造高雅且舒適的住宿氛圍。",
          route: "LuminousGroveSuite",
          image: "room2-1.jpg", // 對應檔案名
          isVisible: false, // 新增這個屬性
        },
        {
          title: "靜謐之森套房",
          description: "融入木質牆面與柔和燈光，打造尊貴且舒適的住宿空間。",
          route: "TranquilForestSuite",
          image: "room3-1.jpg", // 對應檔案名
          isVisible: false, // 新增這個屬性
        },
      ],

      pricingData: [
        {
          type: "木光晨曦套房",
          size: "10",
          beds: "一大床/兩小床",
          price: "NT$ 3,800",
        },
        {
          type: "木光森居套房",
          size: "15",
          beds: "一大床/兩小床",
          price: "NT$ 10,800",
        },
        {
          type: "靜謐之森套房",
          size: "40",
          beds: "一大床/兩小床",
          price: "NT$ 22,000",
        },
      ],
      bookingNotices: [
        "飯店入住時間為下午三點後，退房時間為中午十二點前。",
        "提前入住或延後退房需另收取相關費用，並以飯店回覆為主。",
        "本飯店未設有停車場，請參考飯店附近停車場資訊。",
        "本飯店禁止攜帶寵物入住，導盲犬不在此範圍內。",
        "為確保所有旅客之住宿品質，於晚間10點過後請勿大聲喧嘩、吵鬧，敬請配合。",
        "飯店客房窗戶及陽台基於安全考量，絕無法開啟或使用。",
        "本飯店依據毒品危害防制條例，若有相關行為，飯店有權收取清潔費用。",
        "本飯店視入住房型提供加床服務，如有需求，請直接與飯店人員接洽。",
        "可另提供摺疊床、嬰兒澡盆、嬰兒澡盆，數量有限，請提前預約。",
        "未滿18歲的旅客需有成年人陪同或提供合法家長簽名方可入住。",
        "為確保其他住客權益，如有干擾情況，飯店有權拒絕入住。",
      ],
    };
  },

  // 新增 mounted 生命週期
  mounted() {
    this.setupScrollObserver();
  },

  methods: {
    goToRoomDetail(routeName) {
      // 使用 Vue Router 跳轉到指定的路由名稱
      this.$router.push({ name: routeName });
    },

    navigateToBooking() {
      this.$router.push("/booking").catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err); // 僅記錄非重複導航的錯誤
        }
      });
    },

    setRoomCardRef(el, index) {
      if (el) {
        this.roomCardRefs[index] = el;
      }
    },

    setupScrollObserver() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const index = parseInt(entry.target.dataset.index);
        if (this.rooms[index]) {
          // 進入視窗時顯示，離開視窗時隱藏
          this.rooms[index].isVisible = entry.isIntersecting;
        }
      });
    },
    { threshold: 0.3 }
  );

  this.$nextTick(() => {
    if (this.roomCardRefs) {
      this.roomCardRefs.forEach((element, index) => {
        if (element) {
          element.dataset.index = index;
          observer.observe(element);
        }
      });
    }
  });
},
  },
};
